import { createFeature, createReducer, on } from '@ngrx/store';
import { DisclosureLogin } from './../../interfaces/disclosure-login';
import * as disclosureLoginActions from './disclosure-login.actions';

export interface DisclosureLoginState {
    disclosure: DisclosureLogin;
    loading: boolean;
    error: string | null;
    isSubmittingSuccess: boolean;
}

export interface DisclosureLoginSuccessState {
    loading: boolean;
    error: string | null;
}

export interface DisclosureLoginData {
    disclosureLoginState: DisclosureLoginState;
    disclosureLoginSuccessState: DisclosureLoginSuccessState;
}


export const initialState: DisclosureLoginData = {
    disclosureLoginState: {
        disclosure: {
            contentType: '',
            disclosureContent: '',
            disclosureName: '',
            disclosureVersion: 0
        },
        loading: true,
        error: null,
        isSubmittingSuccess: false
    },
    disclosureLoginSuccessState: {
        loading: false,
        error: null
    }
};


const loadDisclosureLogin: any =
    (state: DisclosureLoginState) => ({ ...state, loading: true, error: null });

const loadDisclosureLoginSuccess: any =
    (state: DisclosureLoginState, disclosureContent: DisclosureLogin) => ({ ...state, disclosure: { ...disclosureContent }, loading: false });

const loadDisclosureLoginFailure: any =
    (state: DisclosureLoginState, error: string) => ({ ...state, error, loading: false });

const loadDisclosureSuccessLogin: any = (state: any) => ({ ...state, loading: true });
const loadDisclosureSuccessLoginSuccess: any = (state: any) => ({ ...state, loading: false });
const loadDisclosureSuccessLoginFailure: any = (state: any) => ({ ...state, error: true })

//For bank info
const loadBankDisclosure: any = (state: DisclosureLoginState) => ({...state, loading: true, error: null});
const loadBankDisclosureSuccess: any = (state: DisclosureLoginState, { disclosureContent, contentType, disclosureVersion }: any) => ({
    ...state, disclosure: { disclosureContent, contentType, disclosureVersion }, loading: false });
const loadBankDisclosureFailure: any = (state: DisclosureLoginState, { error }: any) => ({ ...state, error, loading: false});
const postBankDisclosure: any = (state: DisclosureLoginSuccessState) => ({...state, loading: true, error: null, isSubmittingSuccess: false});
const postBankDisclosureSuccess: any = (state: DisclosureLoginSuccessState) => ({...state,loading: false, isSubmittingSuccess: true});
const postBankDisclosureFailure: any = (state: DisclosureLoginSuccessState, { error }: any) => ({...state, error,loading: false, isSubmittingSuccess: false});

//To clear the disclosure content
const clearDisclosureContent: any = (state: DisclosureLoginState) =>({...state, disclosure:{contentType: '', disclosureContent: '', disclosureName:'', disclosureVersion:0 }});


const reducer = createReducer(
    initialState,
    on(disclosureLoginActions.loadDisclosureLogin, loadDisclosureLogin),
    on(disclosureLoginActions.loadDisclosureLoginSuccess, loadDisclosureLoginSuccess),
    on(disclosureLoginActions.loadDisclosureLoginFailure, loadDisclosureLoginFailure),
    on(disclosureLoginActions.postDisclosureLogin, loadDisclosureSuccessLogin),
    on(disclosureLoginActions.postDisclosureLoginSuccess, loadDisclosureSuccessLoginSuccess),
    on(disclosureLoginActions.postDisclosureLoginFailure, loadDisclosureSuccessLoginFailure),

    on(disclosureLoginActions.loadBankDisclosure, loadBankDisclosure),
    on(disclosureLoginActions.loadBankDisclosureSuccess, loadBankDisclosureSuccess),
    on(disclosureLoginActions.loadBankDisclosureFailure, loadBankDisclosureFailure),
    on(disclosureLoginActions.postBankDisclosure, postBankDisclosure),
    on(disclosureLoginActions.postBankDisclosureSuccess, postBankDisclosureSuccess),
    on(disclosureLoginActions.postBankDisclosureFailure, postBankDisclosureFailure),

    //To clear disclosure
    on(disclosureLoginActions.clearDisclosureContent, clearDisclosureContent)
);

export const DisclosureLogingFeature = createFeature({
    name: 'Disclosure Content',
    reducer: reducer
});
